import React, { ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper';
import styles from './CategorySwiper.module.scss';
type Props = {
    children: ReactNode[] | undefined;
    options?: SwiperOptions;
    swiperClassName?: string;
    slideClassName?: string;
    swiperStylesName?: string;
    slideStylesName?: string;
    spaceBetween?: SwiperOptions['spaceBetween'];
};

export default function CategorySwiper({
    children,
    options = {},
    swiperClassName,
    slideClassName,
    swiperStylesName,
    slideStylesName,
    spaceBetween,
}: Props) {
    return (
        <div>
            <Swiper
                className={`${swiperClassName || ''} ${
                    (swiperStylesName && styles[swiperStylesName]) || ''
                }`}
                {...options}
                spaceBetween={spaceBetween}
            >
                {children?.map((child, index) => {
                    return (
                        <SwiperSlide
                            key={index}
                            className={`${slideClassName || ''} ${
                                (slideStylesName && styles[slideStylesName]) || ''
                            }`}
                        >
                            {child}
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
